export default "__VITE_ASSET__DA$JTAqN__"